import { Box, Tooltip } from '@mui/material'
import List, { ListProps as MuListProps } from '@mui/material/List'

export type SidebarListItem = {
  title: string
  icon: React.ReactNode
  link?: string
  isSelected?: boolean
  expandOnChildRoute?: boolean
  subItems?: {
    link?: string
    title: string
    isSelected?: boolean
  }[]
}
export type SidebarListProps = MuListProps & {
  listItems: SidebarListItem[]
  onClickRoute: (selectedRoute: string, selectedSubroute?: string) => void
}

const MiniDrawer = ({
  listItems,
  onClickRoute,
  ...others
}: SidebarListProps) => {
  return (
    <List
      {...others}
      data-sidebar-mini
      sx={{
        // Fill closed drawer width (theme.spacing(7.5)); center 40px targets — do not set a
        // narrow fixed width *and* horizontal padding or icons clip (was 58px − 20px pad < 40px).
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        px: 0,
        pt: 2.5,
        pb: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        margin: 0,
        marginTop: 2.5,
        borderRadius: 0,
        border: 0,
        backgroundColor: 'transparent',
      }}
      component="nav"
      aria-labelledby="nested-list-subheader">
      {listItems.map((listItem, i) => {
        return (
          <Tooltip
            key={i}
            title={listItem.title}>
            <Box
              component="span"
              onClick={() =>
                onClickRoute(listItem?.subItems?.[0].link || listItem.link!)
              }
              sx={{
                display: 'inline-flex',
                flexShrink: 0,
                cursor: 'pointer',
                borderRadius: '8px',
                backgroundColor: listItem.isSelected
                  ? 'primary.main'
                  : 'transparent',
                color: listItem.isSelected ? 'white' : 'primary.main',
                height: 40,
                width: 40,
                alignItems: 'center',
                justifyContent: 'center',
                '& svg': {
                  width: '22px',
                  height: '22px',
                },
              }}>
              {listItem.icon}
            </Box>
          </Tooltip>
        )
      })}
    </List>
  )
}

export default MiniDrawer
